import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/contacts', { params })
  },
  store (formData) {
    return apiClient.post('/contacts', formData)
  },
  show (id, params) {
    return apiClient.get(`/contacts/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/contacts/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/contacts/${id}`)
  }
}
